<div class="card">
  <div
    class="card__filled"
    [id]="'card-container-' + card.id"
    *ngIf="card?.type === CardTypeEnum.FILLED"
  >
    <iv-live-card-chart-controls
      [card]="card"
      (skipSettingTimestamp)="skipTimestampChanges($event)"
    ></iv-live-card-chart-controls>

    <div class="chart-container" [class.card-chart-full-screen]="isFullScreenMode">
      <iv-live-card-chart-tabs
        [card]="card"
        (skipSettingTimestamp)="skipTimestampChanges($event)"
      ></iv-live-card-chart-tabs>

      <iv-live-spot-chart
        *ngIf="card.chartId === ChartTypeEnum.SPOT_CHART"
        [card]="card"
      ></iv-live-spot-chart>

      <iv-live-ivx-history
        *ngIf="card.chartId === ChartTypeEnum.IVX_HISTORY"
        [card]="card"
      ></iv-live-ivx-history>

      <iv-live-total-oi-chart
        *ngIf="card.chartId === ChartTypeEnum.TOTAL_OPEN_INTEREST_VOLUME"
        [card]="card"
      ></iv-live-total-oi-chart>

      <iv-live-historical-volatility-chart
        *ngIf="card.chartId === ChartTypeEnum.HISTORICAL_VOLATILITY"
        [card]="card"
      ></iv-live-historical-volatility-chart>

      <iv-live-implied-volatility-chart
        *ngIf="card.chartId === ChartTypeEnum.IMPLIED_VOLATILITY"
        [card]="card"
      ></iv-live-implied-volatility-chart>

      <iv-live-iv-premium-chart
        *ngIf="card.chartId === ChartTypeEnum.PREMIUM_CHART"
        [card]="card"
      ></iv-live-iv-premium-chart>

      <iv-live-term-structure-rolling-chart
        *ngIf="card.chartId === ChartTypeEnum.TERM_STRUCTURE_ROLLING"
        [card]="card"
        [skipSettingTimestamp]="skipSettingTimestamp"
      ></iv-live-term-structure-rolling-chart>

      <iv-live-skew-chart
        *ngIf="card.chartId === ChartTypeEnum.SKEW_CHART"
        [card]="card"
        [skipSettingTimestamp]="skipSettingTimestamp"
      ></iv-live-skew-chart>

      <iv-live-iv-difference
        *ngIf="card.chartId === ChartTypeEnum.IV_DIFFERENCE"
        [card]="card"
      ></iv-live-iv-difference>

      <iv-live-single-contract-analyzer
        *ngIf="card.chartId === ChartTypeEnum.SINGLE_CONTRACT_ANALYZER"
        [card]="card"
      ></iv-live-single-contract-analyzer>
    </div>
  </div>

  <div class="card__void" *ngIf="card?.type === CardTypeEnum.VOID"></div>

  <div
    class="card__add-new-chart"
    *ngIf="card?.type === CardTypeEnum.ADD_NEW_CARD"
    (click)="addChartToCard(card)"
  >
    <div
      class="plus"
      [ivLiveHint]="locale.addNewChartHint"
      ivLiveHintPosition="top-right"
    >
      <img
        src="./iv-live/assets/icons/chart-service/add-new-chart/add_new_chart_plus.svg"
        alt="{{locale.addNewChartHint}}"
      >
    </div>
    <span class="plus-text">{{locale.addNewChart}}</span>
  </div>
</div>
